import { TitleUI } from "./TitleUI";
import { getOwnBrand } from "../../utils/product/getOwnBrand";
import { StandardProps } from "../componentMap";
import { sanitiseTitle } from "./sanitiseTitle";
import { useSeo } from "../../hooks/useSeo/useSeo";

export function Title({
  product,
  configProps,
  experiences,
}: Pick<StandardProps, "product" | "configProps" | "experiences">) {
  const ownBrand = getOwnBrand(product);
  const showOtherBrandOnTop = (() => {
    if (typeof experiences?.showOtherBrandOnTop === "boolean")
      return experiences.showOtherBrandOnTop;
    else if (typeof configProps?.showOtherBrandOnTop === "boolean")
      return configProps.showOtherBrandOnTop;
    return false;
  })();
  const brand = (showOtherBrandOnTop && !ownBrand && product.brand?.name) || "";

  const { heading } = useSeo(product);

  const title = sanitiseTitle(heading, ownBrand, brand);
  const otherBrand = brand && heading.trim() === title ? "" : brand;

  return <TitleUI title={title} ownBrand={ownBrand} otherBrand={otherBrand} />;
}
